import { useEffect, useState } from "react";
import { getWatchlist } from "../../services/watchlist.service";
import { useAuthFetch } from "../../services/clerk.service";
import WatchlistAdd from "./watchlist-add.component";
import WatchlistItem from "./watchlist-item.component";

const WatchlistList = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const authFetch = useAuthFetch();

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getWatchlist(authFetch);
        setItems(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [authFetch]);

  const handleAdded = (item) => {
    setItems((prev) => [item, ...prev]);
  };

  const handleRemoved = (removed) => {
    setItems((prev) =>
      prev.filter(
        (i) =>
          !(i.ticker === removed.ticker && i.alert_type === removed.alert_type),
      ),
    );
  };

  // Group items by ticker so CONVICTION + UPSIDE for same ticker appear together
  const grouped = items.reduce((acc, item) => {
    if (!acc[item.ticker]) acc[item.ticker] = [];
    acc[item.ticker].push(item);
    return acc;
  }, {});

  return (
    <div className="wl-wrap">
      <WatchlistAdd onAdded={handleAdded} />

      <div className="wl-list">
        {loading && (
          <div className="wl-state">
            <div className="wl-spinner" />
            <span className="wl-state-label">Loading watchlist…</span>
          </div>
        )}

        {!loading && error && <div className="wl-error">{error}</div>}

        {!loading && !error && items.length === 0 && (
          <div className="wl-empty">
            <div className="wl-empty-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M10 3l1.8 5.5H17l-4.6 3.3 1.7 5.2L10 13.8l-4.1 3.2 1.7-5.2L3 8.5h5.2L10 3z"
                  stroke="#4a5568"
                  strokeWidth="1.3"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <p className="wl-empty-title">No stocks watched yet</p>
            <p className="wl-empty-sub">
              Add a ticker above to start tracking conviction changes and upside
              alerts.
            </p>
          </div>
        )}

        {!loading &&
          !error &&
          Object.entries(grouped).map(([ticker, tickerItems]) => (
            <div key={ticker} className="wl-group">
              {tickerItems.map((item) => (
                <WatchlistItem
                  key={`${item.ticker}-${item.alert_type}`}
                  item={item}
                  onRemoved={handleRemoved}
                />
              ))}
            </div>
          ))}
      </div>
    </div>
  );
};

export default WatchlistList;
